import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

export default class PassInterceptionTouchdownStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            play.historyContains(FootballState.PassIntercepted) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const passInterceptedFragment =
            play.getPreceedingFragment(fragment, [
                FootballState.PassIntercepted
            ]) || fragment;

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: passInterceptedFragment.returnedBy.teamId,
            playerId: passInterceptedFragment.returnedBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: passInterceptedFragment.id,
            category: FootballStatsCategory.INTERCEPTION_RETURN,
            values: {
                touchdowns: 1
            }
        });
    }
}
